var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngineer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 135,
    viewBox: "0 0 174 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4254 134.78C53.7696 134.78 68.6404 133.693 68.6404 132.353C68.6404 131.012 53.7696 129.925 35.4254 129.925C17.0813 129.925 2.21045 131.012 2.21045 132.353C2.21045 133.693 17.0813 134.78 35.4254 134.78Z",
    fill: "#ACCCF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 127.483L173 127.483",
    stroke: "#093269",
    strokeWidth: 1.25903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.843 84.3089H149.646V83.7589C149.645 83.5026 149.697 83.2489 149.798 83.0133C149.899 82.7777 150.047 82.5652 150.233 82.3888C150.419 82.2124 150.639 82.0757 150.879 81.9872C151.12 81.8986 151.376 81.86 151.632 81.8738L154.06 82.0077C154.541 82.0336 154.995 82.2431 155.326 82.5931C155.658 82.9431 155.843 83.4069 155.843 83.8891V84.3089Z",
    fill: "#ACCCF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.854 84.3098H149.656V83.7599C149.656 83.5036 149.708 83.2499 149.809 83.0143C149.91 82.7787 150.058 82.5662 150.244 82.3898C150.43 82.2133 150.65 82.0767 150.89 81.9881C151.131 81.8996 151.387 81.861 151.643 81.8748L154.07 82.0087C154.552 82.0346 155.005 82.2441 155.337 82.5941C155.669 82.944 155.854 83.4079 155.854 83.8901V84.3098Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.843 84.3089H149.646V83.7589C149.645 83.5026 149.697 83.2489 149.798 83.0133C149.899 82.7777 150.047 82.5652 150.233 82.3888C150.419 82.2124 150.639 82.0757 150.879 81.9872C151.12 81.8986 151.376 81.86 151.632 81.8738L154.06 82.0077C154.541 82.0336 154.995 82.2431 155.326 82.5931C155.658 82.9431 155.843 83.4069 155.843 83.8891V84.3089Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.109 71.498C139.097 71.2628 138.996 71.0409 138.826 70.8786C138.655 70.7162 138.429 70.6257 138.193 70.626H131.93C131.695 70.6266 131.469 70.7173 131.299 70.8796C131.128 71.0418 131.027 71.2631 131.015 71.498L132.509 84.5524H141.858L139.109 71.498Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.117 51.4321H153.783L151.164 76.072H153.494C153.686 76.0674 153.87 75.9941 154.013 75.8653C154.156 75.7365 154.247 75.5608 154.272 75.3701L156.75 52.1304C156.762 52.0414 156.755 51.9508 156.728 51.8649C156.702 51.7791 156.657 51.7001 156.596 51.6336C156.536 51.567 156.462 51.5145 156.379 51.4797C156.296 51.4449 156.207 51.4286 156.117 51.4321Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.511 76.0709H117.534C117.445 76.0727 117.356 76.0552 117.274 76.0195C117.192 75.9838 117.119 75.9308 117.059 75.8641C117 75.7974 116.955 75.7186 116.929 75.6331C116.903 75.5476 116.896 75.4575 116.908 75.369L119.383 52.1185C119.406 51.9284 119.498 51.7531 119.64 51.6249C119.782 51.4966 119.966 51.4239 120.157 51.4201H155.134C155.223 51.4177 155.312 51.4348 155.394 51.4701C155.476 51.5053 155.549 51.558 155.609 51.6245C155.668 51.6909 155.713 51.7695 155.739 51.8548C155.765 51.9401 155.772 52.0301 155.76 52.1185L153.285 75.369C153.262 75.5594 153.171 75.7351 153.029 75.8639C152.887 75.9928 152.703 76.0662 152.511 76.0709Z",
    fill: "#ACCCF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M152.521 76.0709H117.544C117.454 76.0727 117.366 76.0552 117.284 76.0195C117.202 75.9838 117.129 75.9308 117.069 75.8641C117.01 75.7974 116.965 75.7186 116.939 75.6331C116.913 75.5476 116.906 75.4575 116.918 75.369L119.393 52.1185C119.416 51.9284 119.507 51.7531 119.649 51.6249C119.792 51.4966 119.975 51.4239 120.167 51.4201H155.144C155.233 51.4177 155.322 51.4348 155.404 51.4701C155.486 51.5053 155.559 51.558 155.619 51.6245C155.678 51.6909 155.722 51.7695 155.749 51.8548C155.775 51.9401 155.782 52.0301 155.77 52.1185L153.295 75.369C153.272 75.5594 153.181 75.7351 153.038 75.8639C152.896 75.9928 152.713 76.0662 152.521 76.0709Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.511 76.0709H117.534C117.445 76.0727 117.356 76.0552 117.274 76.0195C117.192 75.9838 117.119 75.9308 117.059 75.8641C117 75.7974 116.955 75.7186 116.929 75.6331C116.903 75.5476 116.896 75.4575 116.908 75.369L119.383 52.1185C119.406 51.9284 119.498 51.7531 119.64 51.6249C119.782 51.4966 119.966 51.4239 120.157 51.4201H155.134C155.223 51.4177 155.312 51.4348 155.394 51.4701C155.476 51.5053 155.549 51.558 155.609 51.6245C155.668 51.6909 155.713 51.7695 155.739 51.8548C155.765 51.9401 155.772 52.0301 155.76 52.1185L153.285 75.369C153.262 75.5594 153.171 75.7351 153.029 75.8639C152.887 75.9928 152.703 76.0662 152.511 76.0709Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.204 83.5342H130.701C130.567 83.5342 130.438 83.5875 130.343 83.6825C130.248 83.7775 130.195 83.9064 130.195 84.0407C130.195 84.1754 130.248 84.3046 130.343 84.4002C130.438 84.4958 130.567 84.5499 130.701 84.5509H142.2C142.335 84.5499 142.463 84.4958 142.558 84.4002C142.653 84.3046 142.707 84.1754 142.707 84.0407C142.707 83.907 142.654 83.7787 142.559 83.6838C142.465 83.5889 142.337 83.5351 142.204 83.5342Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.862 73.8061H118.879C118.801 73.8079 118.724 73.7927 118.652 73.7617C118.581 73.7306 118.517 73.6845 118.465 73.6263C118.413 73.5682 118.374 73.4995 118.351 73.425C118.328 73.3505 118.322 73.2719 118.333 73.1946L120.503 52.9074C120.523 52.741 120.603 52.5875 120.727 52.4751C120.852 52.3628 121.012 52.2991 121.18 52.296H154.153C154.23 52.2948 154.307 52.3104 154.379 52.3416C154.45 52.3729 154.514 52.419 154.565 52.477C154.617 52.535 154.656 52.6034 154.679 52.6777C154.702 52.752 154.709 52.8303 154.699 52.9074L152.528 73.1946C152.508 73.3589 152.429 73.5106 152.307 73.6226C152.186 73.7346 152.028 73.7997 151.862 73.8061Z",
    fill: "#ACCCF8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M151.854 73.8071H118.871C118.793 73.8088 118.715 73.7937 118.644 73.7626C118.572 73.7316 118.508 73.6854 118.456 73.6273C118.405 73.5692 118.366 73.5005 118.343 73.426C118.32 73.3514 118.314 73.2728 118.324 73.1956L120.495 52.9084C120.515 52.742 120.595 52.5885 120.719 52.4761C120.843 52.3637 121.004 52.3001 121.172 52.2969H154.144C154.222 52.2958 154.299 52.3114 154.37 52.3426C154.442 52.3738 154.505 52.42 154.557 52.478C154.609 52.536 154.648 52.6044 154.671 52.6787C154.694 52.7529 154.701 52.8313 154.691 52.9084L152.52 73.1956C152.499 73.3599 152.421 73.5116 152.299 73.6236C152.177 73.7356 152.019 73.8006 151.854 73.8071Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.862 73.8061H118.879C118.801 73.8079 118.724 73.7927 118.652 73.7617C118.581 73.7306 118.517 73.6845 118.465 73.6263C118.413 73.5682 118.374 73.4995 118.351 73.425C118.328 73.3505 118.322 73.2719 118.333 73.1946L120.503 52.9074C120.523 52.741 120.603 52.5875 120.727 52.4751C120.852 52.3628 121.012 52.2991 121.18 52.296H154.153C154.23 52.2948 154.307 52.3104 154.379 52.3416C154.45 52.3729 154.514 52.419 154.565 52.477C154.617 52.535 154.656 52.6034 154.679 52.6777C154.702 52.752 154.709 52.8303 154.699 52.9074L152.528 73.1946C152.508 73.3589 152.429 73.5106 152.307 73.6226C152.186 73.7346 152.028 73.7997 151.862 73.8061Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4521 87.833H80.1477V126.942C80.1477 127.085 80.0909 127.222 79.9898 127.323C79.8887 127.424 79.7516 127.481 79.6086 127.481H77.9949C77.8519 127.481 77.7148 127.424 77.6137 127.323C77.5126 127.222 77.4558 127.085 77.4558 126.942V87.833H77.4521Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M160.902 84.3096H137.536V87.8337H160.902V84.3096Z",
    fill: "#ACCCF8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.912 84.3096H137.546V87.8337H160.912V84.3096Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.902 84.3096H137.536V87.8337H160.902V84.3096Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1543 87.833H96.8499V126.942C96.8499 127.085 96.793 127.222 96.6919 127.323C96.5908 127.424 96.4537 127.481 96.3107 127.481H94.697C94.6259 127.482 94.5554 127.468 94.4896 127.441C94.4238 127.414 94.3639 127.375 94.3135 127.325C94.263 127.274 94.223 127.215 94.1957 127.149C94.1684 127.084 94.1543 127.013 94.1543 126.942V87.833Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156.65 87.833H159.346V126.942C159.346 127.085 159.289 127.222 159.188 127.323C159.087 127.424 158.95 127.481 158.807 127.481H157.193C157.05 127.481 156.913 127.424 156.812 127.323C156.711 127.222 156.654 127.085 156.654 126.942V87.833H156.65Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M144.199 84.3096H75.8872V87.8337H144.199V84.3096Z",
    fill: "#ACCCF8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M144.198 84.3096H75.8867V87.8337H144.198V84.3096Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M144.199 84.3096H75.8872V87.8337H144.199V84.3096Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.948 87.833H142.64V126.942C142.64 127.085 142.583 127.222 142.482 127.323C142.381 127.424 142.244 127.481 142.101 127.481H140.469C140.326 127.481 140.189 127.424 140.088 127.323C139.986 127.222 139.93 127.085 139.93 126.942V87.833H139.948Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M138.733 82.8594H119.231V84.3103H138.733V82.8594Z",
    fill: "#ACCCF8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M138.733 82.8594H119.231V84.3103H138.733V82.8594Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M138.733 82.8594H119.231V84.3103H138.733V82.8594Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M134.391 3.59766H123.472V70.5559H134.391C135.182 70.5564 135.966 70.401 136.697 70.0986C137.427 69.7963 138.092 69.3529 138.651 68.7938C139.21 68.2346 139.654 67.5708 139.957 66.8401C140.26 66.1094 140.416 65.3262 140.416 64.5352V9.61833C140.416 8.82738 140.26 8.04418 139.957 7.31348C139.654 6.58278 139.21 5.91891 138.651 5.35979C138.092 4.80067 137.427 4.35727 136.697 4.05492C135.966 3.75256 135.182 3.59718 134.391 3.59766Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M132.115 3.59766H40.4196C37.0945 3.59766 34.3989 6.2932 34.3989 9.61833V64.5389C34.3989 67.864 37.0945 70.5595 40.4196 70.5595H132.115C135.441 70.5595 138.136 67.864 138.136 64.5389V9.61833C138.136 6.2932 135.441 3.59766 132.115 3.59766Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M129.999 5.86523H129.069C128.19 5.86523 127.477 6.578 127.477 7.45724V8.38711C127.477 9.26635 128.19 9.97912 129.069 9.97912H129.999C130.878 9.97912 131.591 9.26635 131.591 8.38711V7.45724C131.591 6.578 130.878 5.86523 129.999 5.86523Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.9857 7.92301C43.9857 8.33035 43.8648 8.72853 43.6384 9.06717C43.4121 9.40581 43.0903 9.66968 42.7139 9.82539C42.3375 9.98111 41.9234 10.0217 41.5239 9.94194C41.1245 9.86221 40.7577 9.66577 40.4699 9.37748C40.1821 9.0892 39.9863 8.72203 39.9073 8.32243C39.8283 7.92284 39.8695 7.50878 40.0259 7.13265C40.1823 6.75653 40.4467 6.43524 40.7858 6.20946C41.1248 5.98368 41.5232 5.86355 41.9305 5.86426C42.2007 5.86426 42.4683 5.91754 42.7178 6.02104C42.9674 6.12455 43.1941 6.27625 43.385 6.46747C43.5759 6.65869 43.7272 6.88568 43.8303 7.13543C43.9333 7.38519 43.9861 7.65282 43.9857 7.92301Z",
    fill: "#093269"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9847 7.92399C43.9847 8.33133 43.8639 8.72951 43.6375 9.06814C43.4111 9.40678 43.0893 9.67065 42.713 9.82637C42.3366 9.98208 41.9224 10.0226 41.523 9.94291C41.1235 9.86318 40.7567 9.66674 40.4689 9.37846C40.1811 9.09018 39.9853 8.723 39.9063 8.32341C39.8273 7.92381 39.8686 7.50975 40.0249 7.13363C40.1813 6.7575 40.4458 6.43622 40.7848 6.21044C41.1238 5.98466 41.5222 5.86452 41.9296 5.86524C42.1997 5.86524 42.4673 5.91851 42.7169 6.02202C42.9664 6.12553 43.1932 6.27723 43.384 6.46845C43.5749 6.65967 43.7262 6.88665 43.8293 7.13641C43.9324 7.38617 43.9852 7.6538 43.9847 7.92399V7.92399Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.7067 9.98176C55.8437 9.98176 56.7655 9.06003 56.7655 7.92301C56.7655 6.78599 55.8437 5.86426 54.7067 5.86426C53.5697 5.86426 52.6479 6.78599 52.6479 7.92301C52.6479 9.06003 53.5697 9.98176 54.7067 9.98176Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7062 9.98274C55.8432 9.98274 56.765 9.061 56.765 7.92399C56.765 6.78697 55.8432 5.86523 54.7062 5.86523C53.5692 5.86523 52.6475 6.78697 52.6475 7.92399C52.6475 9.061 53.5692 9.98274 54.7062 9.98274Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3161 9.98274C49.4531 9.98274 50.3748 9.061 50.3748 7.92399C50.3748 6.78697 49.4531 5.86523 48.3161 5.86523C47.1791 5.86523 46.2573 6.78697 46.2573 7.92399C46.2573 9.061 47.1791 9.98274 48.3161 9.98274Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M132.119 12.251H40.4266C38.6102 12.251 37.1377 13.7235 37.1377 15.5399V64.5338C37.1377 66.3503 38.6102 67.8228 40.4266 67.8228H132.119C133.935 67.8228 135.408 66.3503 135.408 64.5338V15.5399C135.408 13.7235 133.935 12.251 132.119 12.251Z",
    fill: "#ACCCF8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M132.106 12.251H40.4139C38.5975 12.251 37.125 13.7235 37.125 15.5399V64.5338C37.125 66.3503 38.5975 67.8228 40.4139 67.8228H132.106C133.923 67.8228 135.395 66.3503 135.395 64.5338V15.5399C135.395 13.7235 133.923 12.251 132.106 12.251Z",
    fill: "#093269"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M132.119 12.251H40.4266C38.6102 12.251 37.1377 13.7235 37.1377 15.5399V64.5338C37.1377 66.3503 38.6102 67.8228 40.4266 67.8228H132.119C133.935 67.8228 135.408 66.3503 135.408 64.5338V15.5399C135.408 13.7235 133.935 12.251 132.119 12.251Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2916 14.5283H40.4201C39.8626 14.5283 39.4106 14.9803 39.4106 15.5378V64.5353C39.4106 65.0929 39.8626 65.5448 40.4201 65.5448H65.2916C65.8491 65.5448 66.301 65.0929 66.301 64.5353V15.5378C66.301 14.9803 65.8491 14.5283 65.2916 14.5283Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M100.145 14.5283H72.0827C71.5252 14.5283 71.0732 14.9803 71.0732 15.5378V64.5353C71.0732 65.0929 71.5252 65.5448 72.0827 65.5448H100.145C100.703 65.5448 101.155 65.0929 101.155 64.5353V15.5378C101.155 14.9803 100.703 14.5283 100.145 14.5283Z",
    fill: "#ACCCF8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M100.139 14.5293H72.0759C71.5184 14.5293 71.0664 14.9813 71.0664 15.5388V64.5363C71.0664 65.0938 71.5184 65.5458 72.0759 65.5458H100.139C100.696 65.5458 101.148 65.0938 101.148 64.5363V15.5388C101.148 14.9813 100.696 14.5293 100.139 14.5293Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M100.145 14.5283H72.0827C71.5252 14.5283 71.0732 14.9803 71.0732 15.5378V64.5353C71.0732 65.0929 71.5252 65.5448 72.0827 65.5448H100.145C100.703 65.5448 101.155 65.0929 101.155 64.5353V15.5378C101.155 14.9803 100.703 14.5283 100.145 14.5283Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M130.678 14.5283H107.996C107.752 14.5293 107.518 14.6269 107.346 14.7998C107.173 14.9728 107.077 15.2069 107.077 15.451V18.2297H131.597V15.451C131.597 15.2069 131.5 14.9728 131.328 14.7998C131.156 14.6269 130.922 14.5293 130.678 14.5283Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M128.502 15.6465H130.687",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M128.502 16.375H130.687",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M130.687 17.1045H128.502",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M119.339 18.2297L118.771 15.9249C118.672 15.5264 118.443 15.1723 118.12 14.9191C117.796 14.666 117.397 14.5284 116.987 14.5283H107.996C107.752 14.5293 107.518 14.6269 107.346 14.7998C107.173 14.9728 107.077 15.2069 107.077 15.451V29.334C107.077 29.5777 107.173 29.8115 107.346 29.9838C107.518 30.1562 107.752 30.253 107.996 30.253H130.678C130.922 30.253 131.156 30.1562 131.328 29.9838C131.5 29.8115 131.597 29.5777 131.597 29.334V18.2297H119.339Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M39.03 62.5387H48.4807C48.6942 62.5387 48.8643 62.4482 48.8643 62.336V52.5307C48.8643 52.4186 48.6942 52.3281 48.4807 52.3281H39.03C38.8202 52.3281 38.6465 52.4186 38.6465 52.5307V62.3216C38.6465 62.4482 38.8093 62.5387 39.03 62.5387Z",
    fill: "#ACCCF8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M39.0188 62.5357H48.4695C48.683 62.5357 48.853 62.4453 48.853 62.3331V52.5278C48.853 52.4156 48.683 52.3252 48.4695 52.3252H39.0188C38.8089 52.3252 38.6353 52.4156 38.6353 52.5278V62.3186C38.6353 62.4453 38.7981 62.5357 39.0188 62.5357Z",
    fill: "#093269"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M39.03 62.5387H48.4807C48.6942 62.5387 48.8643 62.4482 48.8643 62.336V52.5307C48.8643 52.4186 48.6942 52.3281 48.4807 52.3281H39.03C38.8202 52.3281 38.6465 52.4186 38.6465 52.5307V62.3216C38.6465 62.4482 38.8093 62.5387 39.03 62.5387Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8606 62.5387H60.3113C60.5211 62.5387 60.6948 62.4482 60.6948 62.336V52.5307C60.6948 52.4186 60.5211 52.3281 60.3113 52.3281H50.8606C50.6471 52.3281 50.4771 52.4186 50.4771 52.5307V62.3216C50.4771 62.4482 50.6471 62.5387 50.8606 62.5387Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5852 50.6402H53.0359C53.2494 50.6402 53.4194 50.5498 53.4194 50.4376V40.6323C53.4194 40.5201 53.2494 40.4297 53.0359 40.4297H43.5852C43.3753 40.4297 43.2017 40.5201 43.2017 40.6323V50.4376C43.2017 50.5498 43.3753 50.6402 43.5852 50.6402Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4158 50.6402H64.8592C65.0691 50.6402 65.2428 50.5498 65.2428 50.4376V40.6323C65.2428 40.5201 65.0691 40.4297 64.8592 40.4297H55.4158C55.2023 40.4297 55.0322 40.5201 55.0322 40.6323V50.4376C55.0322 50.5498 55.2023 50.6402 55.4158 50.6402Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6726 38.7447H52.1233C52.3368 38.7447 52.5105 38.6543 52.5105 38.5421V28.7368C52.5105 28.6246 52.3368 28.5342 52.1233 28.5342H42.6726C42.4627 28.5342 42.2891 28.6246 42.2891 28.7368V38.5421C42.2891 38.6543 42.4627 38.7447 42.6726 38.7447Z",
    fill: "#ACCCF8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.6628 38.7418H52.1135C52.327 38.7418 52.5007 38.6513 52.5007 38.5392V28.7339C52.5007 28.6217 52.327 28.5312 52.1135 28.5312H42.6628C42.453 28.5312 42.2793 28.6217 42.2793 28.7339V38.5392C42.2793 38.6513 42.453 38.7418 42.6628 38.7418Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6726 38.7447H52.1233C52.3368 38.7447 52.5105 38.6543 52.5105 38.5421V28.7368C52.5105 28.6246 52.3368 28.5342 52.1233 28.5342H42.6726C42.4627 28.5342 42.2891 28.6246 42.2891 28.7368V38.5421C42.2891 38.6543 42.4627 38.7447 42.6726 38.7447Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5027 38.7447H63.9534C64.1669 38.7447 64.3369 38.6543 64.3369 38.5421V28.7368C64.3369 28.6246 64.1669 28.5342 63.9534 28.5342H54.5027C54.2892 28.5342 54.1191 28.6246 54.1191 28.7368V38.5421C54.1191 38.6543 54.2892 38.7447 54.5027 38.7447Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6726 26.8617H52.1233C52.3368 26.8617 52.5105 26.7713 52.5105 26.6591V16.8393C52.5105 16.7272 52.3368 16.6367 52.1233 16.6367H42.6726C42.4627 16.6367 42.2891 16.7272 42.2891 16.8393V26.6446C42.2891 26.7568 42.4627 26.8617 42.6726 26.8617Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5027 26.8617H63.9534C64.1669 26.8617 64.3369 26.7713 64.3369 26.6591V16.8393C64.3369 16.7272 64.1669 16.6367 63.9534 16.6367H54.5027C54.2892 16.6367 54.1191 16.7272 54.1191 16.8393V26.6446C54.1191 26.7568 54.2892 26.8617 54.5027 26.8617Z",
    fill: "#ACCCF8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M54.5061 26.8647H63.9568C64.1703 26.8647 64.3403 26.7742 64.3403 26.662V16.8423C64.3403 16.7301 64.1703 16.6396 63.9568 16.6396H54.5061C54.2926 16.6396 54.1226 16.7301 54.1226 16.8423V26.6476C54.1226 26.7597 54.2926 26.8647 54.5061 26.8647Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5027 26.8617H63.9534C64.1669 26.8617 64.3369 26.7713 64.3369 26.6591V16.8393C64.3369 16.7272 64.1669 16.6367 63.9534 16.6367H54.5027C54.2892 16.6367 54.1191 16.7272 54.1191 16.8393V26.6446C54.1191 26.7568 54.2892 26.8617 54.5027 26.8617Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M128.675 53.6367H105.996C105.752 53.6386 105.519 53.7364 105.346 53.909C105.173 54.0817 105.076 54.3152 105.074 54.5594V68.4713C105.074 68.5925 105.098 68.7124 105.144 68.8244C105.19 68.9363 105.258 69.038 105.344 69.1237C105.43 69.2094 105.531 69.2773 105.643 69.3237C105.755 69.3701 105.875 69.3939 105.996 69.3939H128.675C128.92 69.393 129.154 69.2955 129.327 69.1226C129.499 68.9498 129.597 68.7157 129.598 68.4713V54.5702C129.599 54.4483 129.576 54.3273 129.53 54.2144C129.484 54.1014 129.416 53.9986 129.33 53.9118C129.245 53.8251 129.143 53.7562 129.03 53.709C128.918 53.6617 128.797 53.6372 128.675 53.6367Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M127.148 53.1963H104.469C104.225 53.1963 103.991 53.293 103.818 53.4652C103.645 53.6375 103.547 53.8712 103.546 54.1153V56.8941H128.07V54.1153C128.07 53.8712 127.972 53.6375 127.799 53.4652C127.626 53.293 127.392 53.1963 127.148 53.1963Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M124.971 54.3164H127.157",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M124.971 55.043H127.157",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M127.157 55.7725H124.971",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M115.808 56.8941L115.244 54.5929C115.145 54.1943 114.916 53.8402 114.593 53.5871C114.27 53.334 113.871 53.1964 113.46 53.1963H104.469C104.225 53.1963 103.991 53.293 103.818 53.4652C103.645 53.6375 103.547 53.8712 103.546 54.1153V67.9983C103.547 68.2427 103.645 68.4768 103.818 68.6497C103.99 68.8225 104.225 68.92 104.469 68.9209H127.148C127.393 68.9209 127.627 68.8237 127.8 68.6507C127.973 68.4777 128.07 68.243 128.07 67.9983V56.8941H115.808Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M127.759 32.6214H105.076C104.924 32.6175 104.774 32.6511 104.638 32.7193C104.502 32.7874 104.386 32.888 104.298 33.0122C104.197 33.1656 104.143 33.3456 104.143 33.5296V47.4089C104.143 47.653 104.239 47.8872 104.412 48.0601C104.584 48.233 104.818 48.3306 105.062 48.3316H127.744C127.988 48.3306 128.222 48.233 128.394 48.0601C128.566 47.8872 128.663 47.653 128.663 47.4089V33.544C128.663 33.3024 128.568 33.0705 128.399 32.8979C128.23 32.7254 128 32.6261 127.759 32.6214Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M127.148 31.958H104.469C104.225 31.958 103.991 32.0547 103.818 32.227C103.645 32.3992 103.547 32.633 103.546 32.877V35.6558H128.07V32.877C128.07 32.633 127.972 32.3992 127.799 32.227C127.626 32.0547 127.392 31.958 127.148 31.958Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M124.971 33.0781H127.157",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M124.971 33.8047H127.157",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M127.157 34.5332H124.971",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M115.808 35.6558L115.244 33.3546C115.145 32.956 114.916 32.602 114.593 32.3488C114.27 32.0957 113.871 31.9581 113.46 31.958H104.469C104.225 31.958 103.991 32.0547 103.818 32.227C103.645 32.3992 103.547 32.633 103.546 32.877V46.7636C103.546 47.0083 103.644 47.243 103.817 47.416C103.99 47.5891 104.224 47.6863 104.469 47.6863H127.148C127.393 47.6863 127.627 47.5891 127.8 47.416C127.973 47.243 128.07 47.0083 128.07 46.7636V35.6558H115.808Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1135 74.732H51.5642C51.7777 74.732 51.9477 74.6416 51.9477 74.5294V64.7241C51.9477 64.6119 51.7777 64.5215 51.5642 64.5215H42.1135C41.9037 64.5215 41.73 64.6119 41.73 64.7241V74.5294C41.73 74.6416 41.9037 74.732 42.1135 74.732Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M114.883 65.4248H92.2005C91.9558 65.4248 91.7211 65.522 91.5481 65.695C91.375 65.8681 91.2778 66.1028 91.2778 66.3475V69.1226H115.802V66.3475C115.802 66.1034 115.705 65.8692 115.533 65.6963C115.361 65.5234 115.127 65.4258 114.883 65.4248Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M112.703 66.5479H114.889",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M112.703 67.2744H114.889",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M114.889 68.001H112.703",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M103.54 69.1226L102.975 66.8214C102.877 66.4228 102.648 66.0688 102.324 65.8156C102.001 65.5625 101.602 65.4249 101.192 65.4248H92.2005C91.9558 65.4248 91.7211 65.522 91.5481 65.695C91.375 65.8681 91.2778 66.1028 91.2778 66.3475V80.2268C91.2778 80.4715 91.375 80.7062 91.5481 80.8792C91.7211 81.0523 91.9558 81.1495 92.2005 81.1495H114.883C115.127 81.1485 115.361 81.0509 115.533 80.878C115.705 80.705 115.802 80.4709 115.802 80.2268V69.1226H103.54Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M131.594 1.00293H133.302",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M124.971 1.00293H129.595",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2275 1.00293H120.933",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0669 1.00293H72.7986",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8668 56.4581C95.8958 56.0963 95.9138 55.7345 95.9138 55.3726C95.9138 55.0108 95.8958 54.649 95.8668 54.2872L92.5019 53.853C92.3248 52.5749 91.9243 51.338 91.3187 50.1986L93.8044 47.8468C93.418 47.2229 92.985 46.629 92.5091 46.0703L89.5277 47.6948C88.6319 46.7667 87.5815 46.0015 86.4233 45.4335L87.0493 42.0975C86.3708 41.8179 85.6716 41.5917 84.958 41.4209L83.5107 44.4891C82.2411 44.2623 80.9414 44.2623 79.6718 44.4891L78.2245 41.4209C77.5109 41.5917 76.8116 41.8179 76.1332 42.0975L76.7591 45.4335C75.601 46.0015 74.5505 46.7667 73.6547 47.6948L70.648 46.063C70.1681 46.6229 69.7326 47.2193 69.3455 47.8468L71.8131 50.1769C71.2047 51.3154 70.8029 52.5526 70.6263 53.8313L67.2614 54.2655C67.2324 54.6273 67.2144 54.9891 67.2144 55.3509C67.2144 55.7128 67.2324 56.0746 67.2614 56.4364L70.6263 56.8742C70.8035 58.1516 71.2053 59.3875 71.8131 60.5249L69.3455 62.8587C69.7294 63.4834 70.1613 64.0773 70.6372 64.6352L73.6185 63.007C74.5134 63.9363 75.564 64.7017 76.723 65.2684L76.097 68.6044C76.7754 68.8852 77.4746 69.1126 78.1883 69.2846L79.6356 66.2127C80.9052 66.4395 82.2049 66.4395 83.4745 66.2127L84.9218 69.2846C85.6355 69.1126 86.3347 68.8852 87.0131 68.6044L86.3871 65.2684C87.5461 64.7017 88.5967 63.9363 89.4916 63.007L92.4729 64.6352C92.9488 64.0765 93.3818 63.4826 93.7683 62.8587L91.3006 60.5249C91.91 59.3934 92.3166 58.164 92.5019 56.8923L95.8668 56.4581ZM81.5641 47.1593C82.8207 47.1615 84.0599 47.4531 85.1856 48.0116C86.3113 48.57 87.2932 49.3803 88.0551 50.3795L82.7798 52.8146C82.4001 52.6336 81.9847 52.5397 81.5641 52.5397C81.1435 52.5397 80.7281 52.6336 80.3484 52.8146L75.0731 50.3795C75.8354 49.3807 76.8174 48.5708 77.943 48.0123C79.0686 47.4539 80.3076 47.1621 81.5641 47.1593ZM73.3653 55.3582C73.365 54.3 73.5702 53.2518 73.9695 52.2719L78.7419 55.6368C78.7819 56.0416 78.9085 56.4331 79.1133 56.7846C79.3181 57.1361 79.5962 57.4394 79.9287 57.6738L80.4569 63.4629C78.495 63.1971 76.6958 62.2297 75.3921 60.7397C74.0883 59.2497 73.3683 57.338 73.3653 55.3582ZM82.6713 63.4738L83.1995 57.6847C83.5327 57.4509 83.8112 57.1478 84.0161 56.7962C84.221 56.4445 84.3473 56.0527 84.3863 55.6476L89.1587 52.2827C89.6326 53.4406 89.8348 54.6918 89.7499 55.9401C89.6649 57.1883 89.295 58.4005 88.6686 59.4836C88.0422 60.5666 87.1759 61.4917 86.1363 62.1878C85.0966 62.8839 83.9113 63.3325 82.6713 63.4991V63.4738Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 1.25903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7557 55.3593C82.7564 55.5956 82.687 55.8268 82.5562 56.0237C82.4255 56.2205 82.2392 56.3741 82.0211 56.465C81.803 56.5559 81.5628 56.5801 81.331 56.5345C81.0991 56.4888 80.886 56.3754 80.7187 56.2085C80.5513 56.0417 80.4373 55.8289 80.3909 55.5972C80.3445 55.3655 80.3679 55.1252 80.4582 54.9069C80.5485 54.6885 80.7015 54.5018 80.8979 54.3704C81.0944 54.2391 81.3254 54.1689 81.5617 54.1689C81.8777 54.1689 82.1809 54.2942 82.4047 54.5174C82.6285 54.7405 82.7547 55.0433 82.7557 55.3593Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 1.25903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8252 31.7217C95.8469 31.4612 95.8577 31.2007 95.8577 30.933C95.8577 30.6652 95.8577 30.4083 95.8252 30.1478L93.4191 29.8366C93.293 28.9228 93.0063 28.0384 92.5724 27.2243L94.3381 25.5563C94.0619 25.1102 93.7523 24.6856 93.4118 24.2863L91.2771 25.4514C90.6373 24.7861 89.8853 24.2386 89.0555 23.8341L89.5042 21.4461C89.0224 21.2489 88.5265 21.088 88.0207 20.9648L86.9787 23.1575C86.0706 22.9934 85.1405 22.9934 84.2325 23.1575L83.1941 20.9648C82.6811 21.0831 82.1779 21.2403 81.6889 21.4352L82.1376 23.8232C81.3089 24.2278 80.5581 24.7753 79.9196 25.4405L77.7885 24.2755C77.4469 24.6739 77.1372 25.0985 76.8622 25.5455L78.6134 27.2243C78.1811 28.0391 77.8946 28.9232 77.7668 29.8366L75.3607 30.1478C75.3426 30.4083 75.3281 30.6688 75.3281 30.933C75.3281 31.1971 75.3281 31.4612 75.3607 31.7217L77.7668 32.0329C77.8946 32.9464 78.1811 33.8304 78.6134 34.6452L76.8514 36.3132C77.1273 36.7584 77.4369 37.1818 77.7776 37.5796L79.9087 36.4181C80.5492 37.0812 81.2996 37.6284 82.1267 38.0355L81.678 40.4199C82.1637 40.6209 82.6646 40.783 83.176 40.9047L84.2144 38.7121C85.1229 38.8712 86.0521 38.8712 86.9606 38.7121L88.0026 40.9047C88.5127 40.7825 89.0123 40.6204 89.497 40.4199L89.0483 38.0355C89.8765 37.6285 90.6281 37.0813 91.2699 36.4181L93.401 37.5796C93.7406 37.1809 94.0502 36.7576 94.3272 36.3132L92.5616 34.6452C92.9955 33.8311 93.2821 32.9467 93.4082 32.0329L95.8252 31.7217ZM85.6002 25.0715C86.4972 25.0718 87.3822 25.2786 88.1865 25.6758C88.9908 26.0729 89.693 26.6498 90.2387 27.3618L86.4685 29.1022C86.1971 28.9734 85.9005 28.9066 85.6002 28.9066C85.2998 28.9066 85.0032 28.9734 84.7318 29.1022L80.958 27.3618C81.5043 26.6495 82.2071 26.0725 83.012 25.6753C83.817 25.2782 84.7025 25.0716 85.6002 25.0715ZM79.7351 30.933C79.735 30.176 79.8825 29.4264 80.1693 28.7259L83.5812 31.132C83.6104 31.4202 83.7014 31.6987 83.8482 31.9485C83.9949 32.1983 84.1939 32.4135 84.4315 32.5792L84.7933 36.7257C83.3935 36.532 82.1108 35.8392 81.1814 34.7748C80.2519 33.7104 79.7383 32.3461 79.7351 30.933ZM86.3889 36.7221L86.7688 32.5756C87.0054 32.4088 87.2037 32.1934 87.3503 31.9438C87.4969 31.6942 87.5886 31.4162 87.6191 31.1283L91.0274 28.7222C91.3654 29.5497 91.5092 30.4435 91.448 31.3351C91.3867 32.2268 91.122 33.0925 90.6742 33.866C90.2263 34.6394 89.6072 35.3 88.8644 35.7969C88.1216 36.2939 87.2747 36.6141 86.3889 36.7329V36.7221Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 1.25903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5995 31.7879C86.0711 31.7879 86.4534 31.4056 86.4534 30.934C86.4534 30.4624 86.0711 30.0801 85.5995 30.0801C85.1279 30.0801 84.7456 30.4624 84.7456 30.934C84.7456 31.4056 85.1279 31.7879 85.5995 31.7879Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 1.25903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5887 66.0213C69.5887 65.8476 69.614 65.6594 69.614 65.5002C69.614 65.341 69.614 65.1384 69.5887 64.9756L67.9858 64.7658C67.9025 64.1567 67.7113 63.5674 67.4213 63.0254L68.5973 61.9146C68.4142 61.6171 68.2085 61.3341 67.9822 61.068L66.5602 61.8422C66.1334 61.3976 65.6327 61.0303 65.0804 60.7568L65.3771 59.1684C65.0547 59.0334 64.7219 58.9245 64.3821 58.8428L63.6874 60.29C63.3854 60.2346 63.079 60.2068 62.772 60.2068C62.465 60.2071 62.1586 60.235 61.8566 60.29L61.1655 58.8428C60.8246 58.9251 60.4907 59.0339 60.1669 59.1684L60.4672 60.7568C59.9143 61.0294 59.4135 61.3968 58.9873 61.8422L57.5654 61.068C57.3379 61.3331 57.1322 61.6163 56.9503 61.9146L58.1262 63.0254C57.8351 63.5672 57.6427 64.1565 57.5582 64.7658L55.9553 64.9756C55.9553 65.1493 55.9336 65.3374 55.9336 65.5002C55.9336 65.6631 55.9336 65.8621 55.9553 66.0213L57.5582 66.2311C57.6427 66.8403 57.8351 67.4297 58.1262 67.9715L56.9467 69.0822C57.1311 69.3798 57.3379 69.6629 57.5654 69.9289L58.9873 69.1546C59.4125 69.6012 59.9135 69.9687 60.4672 70.2401L60.1669 71.8285C60.4907 71.9629 60.8246 72.0718 61.1655 72.1541L61.8566 70.6887C62.1586 70.7438 62.465 70.7717 62.772 70.7719C63.079 70.772 63.3854 70.7442 63.6874 70.6887L64.3821 72.1541C64.7219 72.0723 65.0547 71.9635 65.3771 71.8285L65.0804 70.2401C65.6335 69.9678 66.1344 69.6004 66.5602 69.1546L67.9822 69.9289C68.2085 69.6628 68.4142 69.3798 68.5973 69.0822L67.4213 67.9715C67.7113 67.4295 67.9025 66.8401 67.9858 66.2311L69.5887 66.0213ZM62.772 61.5962C63.3703 61.5959 63.9606 61.7335 64.4971 61.9983C65.0336 62.2631 65.5019 62.648 65.8655 63.1231L63.3509 64.2845C63.1702 64.1981 62.9723 64.1536 62.772 64.1543C62.5718 64.1544 62.3741 64.1989 62.1931 64.2845L59.6784 63.1231C60.0426 62.6486 60.511 62.2641 61.0474 61.9994C61.5838 61.7347 62.1738 61.5967 62.772 61.5962ZM58.8643 65.5075C58.8646 65.0025 58.9629 64.5024 59.1538 64.0349L61.426 65.6377C61.4457 65.8311 61.5065 66.0181 61.6045 66.186C61.7025 66.3539 61.8353 66.4988 61.9941 66.611L62.2473 69.3753C61.3099 69.2483 60.4504 68.7856 59.8283 68.0729C59.2062 67.3603 58.8636 66.4462 58.8643 65.5002V65.5075ZM63.3002 69.3753L63.5535 66.611C63.7117 66.4986 63.844 66.3535 63.9414 66.1856C64.0387 66.0177 64.099 65.8309 64.118 65.6377L66.3938 64.0349C66.6176 64.5867 66.7123 65.1823 66.6707 65.7763C66.6291 66.3703 66.4524 66.9469 66.1539 67.4621C65.8555 67.9774 65.4432 68.4176 64.9486 68.7492C64.454 69.0808 63.8902 69.2949 63.3002 69.3753Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 1.25903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3387 65.5007C63.3387 65.613 63.3054 65.7228 63.243 65.8163C63.1806 65.9097 63.0919 65.9825 62.9881 66.0255C62.8843 66.0685 62.7701 66.0797 62.6599 66.0578C62.5497 66.0359 62.4485 65.9818 62.369 65.9023C62.2896 65.8229 62.2355 65.7217 62.2136 65.6115C62.1916 65.5013 62.2029 65.3871 62.2459 65.2833C62.2889 65.1795 62.3617 65.0908 62.4551 65.0283C62.5485 64.9659 62.6583 64.9326 62.7707 64.9326C62.9214 64.9326 63.0658 64.9925 63.1724 65.099C63.2789 65.2055 63.3387 65.35 63.3387 65.5007V65.5007Z",
    stroke: "#093269",
    strokeWidth: 1.25903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9269 68.7439L36.7334 67.3545L27.9702 102.198L14.7095 123.002L9.36182 120.209C9.36182 120.209 15.5923 104.882 20.1476 99.2633C20.1476 99.2633 21.1173 88.1374 22.0002 82.3121C22.0002 82.3121 20.3466 74.1748 19.9269 68.7439Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5941 67.7793L24.3179 68.3799C24.3179 68.3799 23.739 75.9166 29.3182 81.6514L31.9161 86.4673L34.5031 76.1771L31.5941 67.7793Z",
    fill: "#D5E6FB",
    stroke: "#D5E6FB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9269 68.7439L36.7334 67.3545L27.9702 102.198L14.7095 123.002L9.36182 120.209C9.36182 120.209 15.5923 104.882 20.1476 99.2633C20.1476 99.2633 21.1173 88.1374 22.0002 82.3121C22.0002 82.3121 20.3466 74.1748 19.9269 68.7439Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9908 101.774C19.6762 101.946 19.3875 102.162 19.1333 102.415",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2942 99.1116C21.2942 99.1116 24.5723 98.54 25.2489 100.819C25.7808 102.603 23.3928 100.924 21.0337 101.406",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2442 68.7188L38.6749 66.7686L47.4382 94.3175L54.7687 119.124L48.7407 121.476C48.7407 121.476 41.6419 106.127 40.0064 97.7656C40.0064 97.7656 33.4539 86.6071 31.1274 81.2486C29.2812 79.7251 27.796 77.811 26.7786 75.6444C25.7613 73.4777 25.2372 71.1124 25.2442 68.7188Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6519 81.0273C38.2385 81.0938 38.7987 81.3079 39.28 81.6497",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3993 77.8506C35.4296 78.6719 31.54 78.9976 32.4518 80.5859C32.9946 81.5303 34.507 81.1323 36.1243 81.0129",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9033 97.1742C40.9033 97.1742 42.8861 95.9187 44.4817 97.1742",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4281 131.216L4.87158 124.667L5.18998 123.91L5.6495 124.048C5.6495 124.048 6.39846 122.962 8.25821 120.69C8.7755 119.076 9.54879 117.555 10.5485 116.186C10.5485 116.186 17.8826 118.512 16.6994 121.276L15.1328 124.008C15.8496 125.22 16.6348 126.391 17.4846 127.514C17.4846 127.514 19.2069 128.621 19.6555 128.715C19.86 128.746 20.0556 128.82 20.2292 128.932C20.4027 129.044 20.5501 129.193 20.6616 129.367C20.773 129.541 20.8458 129.737 20.8751 129.942C20.9044 130.146 20.8895 130.355 20.8314 130.553L21.2765 130.647L20.9942 131.436L16.4281 131.216Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1122 117.209C12.2771 116.817 11.4193 116.475 10.5432 116.186C9.5435 117.555 8.77022 119.076 8.25293 120.69C11.3465 122.608 13.1122 117.209 13.1122 117.209Z",
    fill: "#ACCCF8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.1146 117.207C12.2796 116.814 11.4217 116.472 10.5457 116.183C9.54594 117.552 8.77266 119.073 8.25537 120.687C11.3489 122.605 13.1146 117.207 13.1146 117.207Z",
    fill: "#093269"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1122 117.209C12.2771 116.817 11.4193 116.475 10.5432 116.186C9.5435 117.555 8.77022 119.076 8.25293 120.69C11.3465 122.608 13.1122 117.209 13.1122 117.209Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5372 124.628C15.3506 124.901 15.0939 125.119 14.7941 125.259C14.4943 125.399 14.1623 125.456 13.833 125.424",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1943 125.61C16.1943 125.61 16.0242 126.403 14.7832 126.75",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8571 126.603C16.8571 126.603 17.0778 127.377 15.7427 128.093",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7549 130.268L19.9982 130.43",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77783 125.256L16.4832 130.173L17.2683 129.174",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4458 124.507L7.04642 124.847",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7871 120.61C47.7871 120.61 54.2999 116.529 55.6603 119.21L56.724 122.174C56.724 122.174 61.9632 122.97 63.5588 122.626C63.7569 122.573 63.9641 122.562 64.1666 122.595C64.3691 122.628 64.5623 122.703 64.7334 122.817C64.9045 122.93 65.0495 123.078 65.1589 123.252C65.2683 123.425 65.3395 123.62 65.3679 123.823L65.8129 123.729L65.8781 124.565L50.5623 130.43L50.2004 129.707L50.6021 129.446C50.6021 129.446 50.2728 128.18 49.7337 125.282C48.8381 123.839 48.1808 122.262 47.7871 120.61Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2294 119.317C49.3901 119.699 48.5746 120.13 47.7871 120.609C48.1827 122.258 48.8412 123.833 49.7373 125.273C53.1963 124.162 50.2294 119.317 50.2294 119.317Z",
    fill: "#ACCCF8"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.2265 119.318C49.3872 119.7 48.5716 120.131 47.7842 120.61C48.1797 122.259 48.8382 123.834 49.7344 125.274C53.1934 124.163 50.2265 119.318 50.2265 119.318Z",
    fill: "#093269"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2294 119.317C49.3901 119.699 48.5746 120.13 47.7871 120.609C48.1827 122.258 48.8412 123.833 49.7373 125.273C53.1963 124.162 50.2294 119.317 50.2294 119.317Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0425 124.362L64.7589 124.087",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2427 128.11L63.1326 124.709",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2339 129.262L52.5039 128.777",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4524 122.275C57.539 122.594 57.5383 122.93 57.4505 123.248C57.3627 123.567 57.1909 123.855 56.9531 124.084",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6269 122.413C58.6269 122.413 59.119 123.057 58.5835 124.222",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M59.813 122.55C59.813 122.55 60.5366 122.883 60.2255 124.359",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8988 31.3867C14.5782 32.9293 13.7114 34.8081 13.3951 36.814C12.827 40.2296 10.1387 47.513 11.0034 48.0557C11.8682 48.5985 20.0019 54.5685 20.0019 54.5685L23.5694 51.2651L18.5039 44.8102L21.015 33.8399L15.8988 31.3867Z",
    fill: "#ACCCF8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.8925 31.3857C14.5718 32.9283 13.7051 34.8071 13.3887 36.813C12.8207 40.2286 10.1323 47.512 10.9971 48.0548C11.8618 48.5975 19.9955 54.5675 19.9955 54.5675L23.5631 51.2641L18.4976 44.8092L21.0086 33.8389L15.8925 31.3857Z",
    fill: "#093269"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8988 31.3867C14.5782 32.9293 13.7114 34.8081 13.3951 36.814C12.827 40.2296 10.1387 47.513 11.0034 48.0557C11.8682 48.5985 20.0019 54.5685 20.0019 54.5685L23.5694 51.2651L18.5039 44.8102L21.015 33.8399L15.8988 31.3867Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4634 46.6192C13.0088 46.0999 13.6845 45.738 14.419 45.5717C15.1535 45.4054 15.9193 45.4411 16.6352 45.6749",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01477 62.8778C5.99572 63.7985 7.20351 64.4421 8.51472 64.7431C9.82592 65.044 11.1935 64.9915 12.4777 64.5907C13.762 64.19 14.9168 63.4555 15.8242 62.4623C16.7315 61.4691 17.3589 60.2527 17.6423 58.9376L76.2208 38.7228C77.2548 39.5834 78.4988 40.154 79.8257 40.3764C81.1525 40.5987 82.5146 40.4648 83.7727 39.9882C85.0309 39.5117 86.1399 38.7097 86.9865 37.6641C87.8331 36.6185 88.3869 35.3669 88.5914 34.0372V33.1254L82.9434 35.0756L79.9909 32.5103L80.6241 29.254L86.2721 27.3074V26.3956C85.2912 25.474 84.0832 24.8295 82.7715 24.5281C81.4598 24.2266 80.0915 24.2789 78.8067 24.6797C77.5219 25.0805 76.3666 25.8154 75.4589 26.8092C74.5513 27.803 73.9239 29.02 73.641 30.3358L15.0625 50.5506C14.0284 49.69 12.7844 49.1194 11.4576 48.897C10.1307 48.6747 8.76864 48.8087 7.51052 49.2852C6.2524 49.7617 5.14336 50.5638 4.29675 51.6093C3.45014 52.6549 2.89632 53.9065 2.69189 55.2362V56.1661L8.33989 54.2159L11.2923 56.7776L10.6628 60.0339L5.01477 61.9552V62.8778Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8426 32.3814L80.6241 28.3507L86.2721 26.4005C85.2912 25.4789 84.0832 24.8344 82.7715 24.5329C81.4598 24.2314 80.0915 24.2838 78.8067 24.6846C77.5219 25.0854 76.3666 25.8202 75.4589 26.814C74.5513 27.8078 73.9239 29.0249 73.641 30.3407L15.0625 50.5555C14.0284 49.6949 12.7844 49.1243 11.4576 48.9019C10.1307 48.6796 8.76864 48.8135 7.51052 49.2901C6.2524 49.7666 5.14336 50.5686 4.29675 51.6142C3.45014 52.6598 2.89632 53.9114 2.69189 55.2411L8.33989 53.2945L11.4443 55.9864L10.6628 60.0207L5.01477 61.9565C5.99572 62.8771 7.20351 63.5208 8.51472 63.8217C9.82592 64.1227 11.1935 64.0701 12.4777 63.6694C13.762 63.2686 14.9168 62.5341 15.8242 61.5409C16.7315 60.5477 17.3589 59.3314 17.6423 58.0162L76.2208 37.8014C77.256 38.6623 78.5015 39.2326 79.8296 39.454C81.1577 39.6754 82.5208 39.5399 83.7794 39.0614C85.0379 38.5829 86.1467 37.7785 86.9922 36.7306C87.8377 35.6827 88.3896 34.429 88.5914 33.0978L82.9434 35.0769L79.8426 32.3814Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5408 19.7831C35.5408 19.7831 34.4083 17.5326 34.2419 16.7149C34.1225 16.136 34.3576 14.9275 34.2419 14.3486C33.9633 12.9917 32.0709 9.25416 32.0709 9.25416C31.9937 9.09348 31.8766 8.95523 31.7308 8.85254L30.602 10.2166H27.5808L22.9712 16.3096L25.2398 21.7948L24.5741 22.5836C24.9829 22.9852 25.2398 23.2168 25.2398 23.2168L24.5741 27.1968L31.0868 27.8553L31.2569 25.3225H33.236C33.5025 25.3216 33.7578 25.2153 33.9462 25.0269C34.1346 24.8385 34.2409 24.5832 34.2419 24.3167V20.8686L35.15 20.6117C35.2339 20.5885 35.3117 20.5475 35.3782 20.4914C35.4447 20.4354 35.4984 20.3657 35.5355 20.287C35.5726 20.2084 35.5923 20.1226 35.5932 20.0356C35.5941 19.9487 35.5762 19.8625 35.5408 19.7831Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2404 23.2063L26.3476 21.0354C26.3476 21.0354 23.9596 20.1852 24.4553 18.0504C24.951 15.9157 26.9446 17.7284 26.9446 17.7284H27.5814L28.1459 15.2608C28.1459 15.2608 29.5316 13.7737 29.4339 13.2527C29.3591 12.8741 29.26 12.5006 29.1372 12.1347C29.1372 12.1347 33.6166 11.4508 33.034 8.8168C32.4515 6.18275 26.4417 7.18138 26.4417 7.18138C26.4417 7.18138 24.6688 4.01908 20.1135 10.1664C20.1135 10.1664 16.792 12.0623 19.2198 16.0423C20.9091 18.6801 22.9328 21.0882 25.2404 23.2063Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5868 12.8418C27.5868 12.8418 24.1061 19.7887 21.1428 20.3025L20.1768 18.9927C20.1768 18.9927 20.3468 17.8819 22.2246 17.7264C22.2246 17.7264 23.9976 16.9448 26.0961 13.2507L27.5868 12.8418Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0747 21.3027C32.3177 21.5721 32.6224 21.7787 32.9627 21.9047C33.3029 22.0307 33.6686 22.0725 34.0285 22.0264",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0349 16.0413C33.0349 16.3488 32.9155 16.6021 32.7708 16.6021C32.626 16.6021 32.5103 16.3488 32.5103 16.0413C32.5103 15.7337 32.6297 15.4805 32.7708 15.4805C32.9119 15.4805 33.0349 15.7301 33.0349 16.0413Z",
    fill: "#093269"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0362 13.9139C32.6752 13.8351 32.298 13.8867 31.9715 14.0596C31.6449 14.2325 31.3902 14.5154 31.2524 14.8583",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1098 17.8465C20.0488 17.9277 19.9683 17.9921 19.8757 18.0337C19.7831 18.0753 19.6814 18.0928 19.5803 18.0845C19.4791 18.0762 19.3816 18.0424 19.2971 17.9862C19.2125 17.93 19.1436 17.8533 19.0967 17.7632C17.9461 15.5598 15.587 9.6404 21.9153 6.71691C29.4375 3.24344 33.4681 7.97603 33.4681 7.97603L35.469 8.18951L36.0009 9.11938L20.9492 16.7284L20.1098 17.8465Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8506 28.2743C22.1677 27.6406 22.6502 27.1044 23.2469 26.7222C23.8437 26.3401 24.5326 26.1263 25.2409 26.1034C27.741 25.9876 31.5799 26.3314 32.5641 28.723C32.5641 28.723 37.9588 30.2824 39.2035 34.1141C40.4481 37.9458 38.6752 55.5989 38.6752 55.5989C38.6752 55.5989 40.2672 62.6616 39.2794 67.3689C39.2794 67.3689 33.816 69.2431 19.0176 69.5398C19.0176 69.5398 17.9321 60.3966 18.5508 57.1511C18.5508 57.1511 14.2343 34.324 15.9023 31.3607C17.5703 28.3974 21.8506 28.2743 21.8506 28.2743Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6704 45.4285C20.2526 45.3271 17.9587 46.4162 16.8696 47.2376C17.0867 48.6848 17.3074 50.067 17.5173 51.3225C18.1975 50.7581 19.9885 50.1321 24.5583 50.0417C29.4475 49.9567 34.3201 50.6317 39.0021 52.0425C39.1034 50.8159 39.2156 49.3578 39.3169 47.8056C36.8457 47.1471 30.2063 45.5515 24.6704 45.4285Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6755 55.6061C38.6755 55.6061 38.7081 55.2696 38.7623 54.6799C36.6927 54.1625 30.8638 52.8346 25.2737 52.7079C20.6858 52.603 18.7827 53.5872 18.0156 54.2638C18.3304 56.0512 18.5439 57.1764 18.5439 57.1764C18.5005 57.3971 18.4679 57.6468 18.439 57.9C19.3073 57.4007 21.1779 56.9159 25.1616 56.8363C29.9163 56.7568 34.656 57.3922 39.2218 58.7214C38.965 56.8906 38.6755 55.6061 38.6755 55.6061Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1162 28.3936C30.4274 28.4695 30.7422 28.5564 31.0642 28.6541",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 27.9694C25.422 27.7271 27.3041 27.7968 29.1358 28.1756",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M34.29 42.7787C34.0568 39.5 34.6881 36.2175 36.1208 33.2592C38.5233 28.1938 40.4627 38.3898 40.4627 38.3898C40.4627 38.3898 43.2161 42.7317 43.8782 45.8361C43.8782 45.8361 46.2409 43.5385 55.9268 42.7787L57.0629 46.8528C57.0629 46.8528 43.7154 53.409 40.9041 52.9096C38.8236 52.5695 34.29 42.7787 34.29 42.7787Z",
    fill: "#ACCCF8",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0775 44.2275C39.0734 44.6326 39.1074 45.0372 39.1788 45.436",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5903 42.7792C36.5903 42.7792 38.5369 38.5098 39.5572 38.7992C40.2809 39.0127 39.5066 40.7096 39.1954 42.7792",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7734 42.3809C54.7734 42.3809 56.3401 45.1018 56.2641 47.9421L58.1637 46.9109C58.1637 46.9109 57.9755 43.4483 56.6477 42.2832L54.7734 42.3809Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2642 42.8879L59.3686 42.3813C59.6102 41.888 59.9872 41.4737 60.4555 41.1866C60.9239 40.8996 61.4642 40.7518 62.0135 40.7604C63.0746 40.7915 64.1326 40.6297 65.136 40.2828C65.1656 40.2707 65.1979 40.2662 65.2297 40.2697C65.2616 40.2733 65.292 40.2848 65.3183 40.3031C65.3445 40.3215 65.3658 40.3461 65.3801 40.3748C65.3944 40.4035 65.4013 40.4353 65.4001 40.4673C65.4001 40.9087 65.0672 41.7518 62.8999 41.9472C62.8999 41.9472 64.8574 43.1375 65.4001 42.6708C65.5436 42.5311 65.723 42.4338 65.9184 42.3897C66.1138 42.3457 66.3176 42.3565 66.5073 42.4211C66.5073 42.4211 66.5724 43.9444 65.4942 44.0059C65.4942 44.0059 65.2409 44.9937 64.4087 44.9756C64.4087 44.9756 63.837 45.7788 63.3956 45.6522C62.9567 45.7453 62.5031 45.7453 62.0641 45.6522C61.2428 45.5111 60.3563 45.3338 60.3563 45.3338L57.4618 46.2383L56.2642 42.8879Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1324 43.2539C65.1324 43.2539 65.1722 43.8762 64.7163 43.9775C64.2604 44.0789 64.8321 44.6252 63.269 45.0992",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9177 47.0732C43.9464 47.9031 43.8438 48.7322 43.6138 49.53",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7785 44.5065C57.6417 43.9474 57.4299 43.4095 57.1489 42.9072",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0046 45.5723C57.9757 45.3986 57.9431 45.2105 57.9033 45.0332",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineer);
export default __webpack_public_path__ + "static/media/Engineer.536a509e90b07dd5404b1d7300b9d04c.svg";
export { ForwardRef as ReactComponent };